export default {
    Id: 'ID',
    Code: 'Mã',
    Name: 'Tên',
    Description: 'Mô tả',
    Quantity: 'Số lượng',
    Price: 'Giá',
    Status: 'Trạng thái',
    Category: 'Danh mục',
    Supplier: 'Nhà cung cấp',
    OrderTotal: 'Tổng đơn hàng',
    Name: 'Tên',
    Unit: 'Đơn vị tính',
    Image: 'Ảnh',
    OrderId: "Mã đơn hàng",
    Product: 'Sản phẩm',
    Order: 'Đơn hàng',
    OrderProcessing: 'Đang xử lý',
    OrderShipped: 'Đã vận chuyển',
    OrderDelivered: 'Đã giao hàng',
    OrderCancelled: 'Đã hủy',
    Customer: 'Khách hàng',
    Contact: 'Liên hệ',
    Conutry: 'Quốc gia',
    City: 'Thành phố',
    Address: 'Địa chỉ',
    PostalCode: 'Mã bưu chính',
    Phone: 'Số điện thoại',
    ShipPhone: 'SDT người giao hàng',
    ShipAddress: 'Địa chỉ giao hàng',
    InvoiceAddress: 'Địa chỉ hóa đơn',
    SameWithShippingAddress: 'Giống địa chỉ giao hàng',
    Employee: 'Nhân viên',
    DateOfBirth: 'Ngày sinh',
    Avatar: 'Ảnh đại diện',
    Department: 'Phòng ban',
    Type: 'Loại',
    Note: 'Ghi chú',
    CategoryInvalid: 'Vui lòng chọn danh mục',
    SupplierInvalid: 'Vui lòng chọn nhà cung cấp',
    CodeInvalid: 'Vui lòng nhập mã',
    QuantityInvalid: 'Vui lòng nhập số lượng',
    PriceInvalid: 'Vui lòng nhập giá',
    StatusInvalid: 'Vui lòng chọn trạng thái',
    NameInvalid: 'Vui lòng nhập tên',
    PhoneInvalid: 'Vui lòng nhập số điện thoại',
    ContactInvalid: 'Vui lòng nhập liên hệ',
    CustomerInvalid: 'Vui lòng chọn khách hàng',
    ShippingPhoneInvalid: 'Vui lòng nhập số điện thoại người giao hàng',
    OrderIdInvalid: 'Vui lòng nhập mã đơn hàng',
    DescriptionInvalid: 'Vui lòng nhập mô tả',
    UnitInvalid: 'Vui lòng nhập đơn vị tính',
    IdInvalid: 'Vui lòng nhập id',
    AmountInvalid: 'Vui lòng nhập tổng tiền',
    EmployeeInvalid: 'Vui lòng chọn nhân viên',
    EmailInvalid: 'Vui lòng nhập email',
    DateOfBirthInvalid: 'Vui lòng nhập ngày sinh',
    GroupInvalid: 'Vui lòng nhập nhóm',
    NoteInvalid: 'Vui lòng nhập ghi chú',
    CategoryNameInvalid: 'Vui lòng nhập tên danh mục',
    CategoryDescriptionInvalid: 'Vui lòng nhập tên danh mục',
    AddressInvalid: 'Vui lòng nhập địa chỉ',
    CityInvalid: 'Vui lòng nhập thành phố',
    CountryInvalid: 'Vui lòng nhập quốc gia',
    PostalCodeInvalid: 'Vui lòng nhập mã bưu chính',
    PhoneNumberInvalid: 'Vui lòng nhập số điện thoại',
    GroupInvalid: 'Vui lòng chọn nhóm',
    SyncCodeInvalid: 'Vui lòng nhập mã đồng bộ',
    UserNameInvalid: 'Vui lòng nhập tên người dùng',
    PasswordInvalid: 'Vui lòng nhập mật khẩu',
    WorkPhoneInvalid: 'Vui lòng nhập số điện thoại công việc',
    IdentityNumberInvalid: 'Vui lòng nhập số CMND',
    

    AddProductSuccess: 'Thêm sản phẩm thành công',
    AddProductFail: 'Thêm sản phẩm thất bại',

    WorkPhone: 'Số điện thoại công việc',
    SyncCode: 'Mã đồng bộ',
    UserName: 'Tên người dùng',
    Password: 'Mật khẩu',

    SupplierName : 'Tên nhà cung cấp',
    CategoryName  : 'Tên danh mục'
}